module.exports = __webpack_public_path__ + "static/61-657136c12c02106712090fb5455256f8.jpg";